import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import ServicesLanding from "../views/ServicesLanding";
import { Helmet } from "react-helmet-async";

export default function Services(props) {
  const appContext = useContext(AppContext);

  const [view, setView] = useState(null);

  async function init() {
    //run initializations here
  }

  function getView() {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <ServicesLanding />;
    }

    return null;
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const _view = getView();
    if (_view) {
      setView(_view);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  //return desired view
  return (
    <>
      <Helmet>
        <title>Our Services | Group V Limited</title>
        <meta
          name="description"
          content="Explore the services offered by Group V Limited. Learn more about the construction products we sell"
        />
        <meta property="og:title" content="Our Services | Group V Limited" />
        <meta
          property="og:description"
          content="Discover the range of services provided by Group V Limited in Tanzania."
        />
        <meta property="og:url" content="https://groupv.co.tz/#/services" />
      </Helmet>
      {view}
    </>
  );
}
